const invoicePaymentStatusConstants = Object.freeze({
  DUE: 'DUE',
  UNMATCHED: 'UNMATCHED',
  OVERDUE: 'OVERDUE',
  PAID: 'PAID',
  PAID_OUTSIDE: 'PAID_OUTSIDE',
  PROCESSING: 'PROCESSING',
  UPCOMING: 'UPCOMING'
});

const invoiceStatusConstants = Object.freeze({
  MATCHED: 'MATCHED',
  PARSED: 'PARSED',
  PENDING: 'PENDING'
});

const invoiceTypeConstants = Object.freeze({
  INVOICE: 'INVOICE',
  NO_RECEIPT: 'NO_RECEIPT',
  RECEIPT: 'RECEIPT'
});

const invoiceMatchTypeConstants = Object.freeze({
  AUTOMATED: 'AUTOMATED',
  MANUAL: 'MANUAL',
});

const invoiceApprovalStatusConstants = Object.freeze({
  ASSIGNED: 'ASSIGNED',
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  UNASSIGNED: 'UNASSIGNED',
});

const invoiceVatTypeConstants = Object.freeze({
  STANDARD: 'STANDARD',
  REDUCED: 'REDUCED',
  SUPER_REDUCED: 'SUPER_REDUCED',
  EXEMPT: 'EXEMPT'
});

const invoiceSourceTypeConstants = Object.freeze({
  EMAIL: 'EMAIL',
  WEBSITE: 'WEBSITE',
  MOBILE_APP: 'MOBILE_APP',
  ERP: 'ERP',
  SDI: 'SDI',
});

// A line_items entry with this label is a migration-backfill placeholder standing in for
// the invoice's total, not a real itemized line — see CONTEXT.md's "Full Invoice line item".
const invoiceLineItemLabelConstants = Object.freeze({
  FULL_INVOICE: 'full_invoice',
});

// Stands in for "invoices without any invoice tag" inside the invoice_tags filter selection.
// The API takes it as a separate `untagged` flag, see invoicesHelpers.getInvoiceTagQuery.
const NO_INVOICE_TAG_FILTER_VALUE = '__no_tag__';

export {
  NO_INVOICE_TAG_FILTER_VALUE,
  invoicePaymentStatusConstants,
  invoiceStatusConstants,
  invoiceTypeConstants,
  invoiceMatchTypeConstants,
  invoiceApprovalStatusConstants,
  invoiceVatTypeConstants,
  invoiceSourceTypeConstants,
  invoiceLineItemLabelConstants
};
